/**
 * CommentData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { CommentInfo } from './comment_info'
import type { CommentStats } from './comment_stats'
import type { PostData } from './post_data'
import type { UserData } from './user_data'

/**
 * CommentData
 */
export interface CommentData {
  /** 评论ID */
  id?: string
  /** 评论基础信息 */
  info?: CommentInfo
  /** 评论统计信息 */
  stats?: CommentStats
  /** 作者信息 */
  author?: UserData
  /** 帖子信息（评论的是一个post） */
  post?: PostData
}

/**
 * CommentData Schema
 */
export const CommentDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '评论ID',
      format: 'string',
      type: 'string',
      label: '评论ID',
    },
    info: {
      $ref: 'CommentInfo',
      description: '评论基础信息',
      label: '评论基础信息',
    },
    stats: {
      $ref: 'CommentStats',
      description: '评论统计信息',
      label: '评论统计信息',
    },
    author: {
      $ref: 'UserData',
      description: '作者信息',
      label: '作者信息',
    },
    post: {
      $ref: 'PostData',
      description: '帖子信息（评论的是一个post）',
      label: '帖子信息',
    },
  },
  type: 'object',
}
